import { useRouter } from 'next/router';
import { useMemo } from 'react';

import { useUser } from '../../store/hooks/users';
import useCookie from '../useCookie';

import type { IMakePixelProps } from './makePixelLink';
import makePixelLink from './makePixelLink';

export const usePixel = (link?: string, props?: Partial<IMakePixelProps>): string | null => {
  const [cookie] = useCookie();
  const { asPath, pathname } = useRouter();
  const user = useUser();

  return useMemo(() => {
    if (!link) {
      return null;
    }

    return makePixelLink(link, {
      ...props,
      cookie,
      userId: props.userId || user?.sub,
      pathname: asPath,
      route: pathname,
    });
  }, [asPath, cookie, link, pathname, props, user?.sub]);
};
